import { Dialog, Slide } from "@mui/material";
import { List } from "iconoir-react";
import React, { useRef } from "react";
import MainButton from "../button/MainButton";
import CloseIcon from "../image/CloseIcon";
import RichEditor from "../RichEditor/RichEditor";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});
const ContentEditor = ({ open, handleClose, content, handleOK }) => {
    const EDITOR_REF = useRef();
    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
        >
            <div className="px-5 mt-[14px] ">
                <div className="flex items-center gap-5">
                    <span onClick={handleClose}>
                        <CloseIcon />
                    </span>
                    <span className="large-text">Trình soạn thảo</span>
                </div>
                <div className="mb-[70px] min-h-screen mt-7">
                    <RichEditor
                        EDITOR_REF={EDITOR_REF}
                        editorContent={content}
                        placeholder={"Nhập nội dung văn bản"}
                    />
                </div>
            </div>
            <footer className="sticky bottom-0 bg-white px-5 py-[15px] shadow-[0px_0px_8px_rgba(0,0,0,0.25)] flex gap-3 items-center">
                <MainButton
                    style={{ color: "#0073C7 ", backgroundColor: "#F8F8F8" }}
                    onClick={() =>
                        handleOK(EDITOR_REF.current.editor.getData())
                    }
                >
                    OK
                </MainButton>
            </footer>
        </Dialog>
    );
};

export default ContentEditor;
